$(() => {
  window.Geenie.Good = {
    cookie_name: 'is_good',
    /** @param {number} projectId */
    fetchLikedProjects(projectId) {
      const deferred = $.Deferred();

      const checkEnv = () => {
        if (window.Env && window.Env.getAPIBaseURL) {
          const url = `${window.Env.getAPIBaseURL}/v2/liked-projects?project_ids[]=${projectId}`;
          $.ajax({
            type: 'GET',
            url,
            cache: false,
            dataType: 'json',
            xhrFields: {
              withCredentials: true,
            },
          }).then(
            data => deferred.resolve(data),
            error => deferred.reject(error),
          );
        } else {
          setTimeout(checkEnv, 500);
        }
      };

      checkEnv();
      return deferred.promise();
    },
    get_promise_update_regist(project_id, action_num) {
      return $.ajax({
        type: 'POST',
        url: '/api/good/regist',
        cache: false,
        dataType: 'json',
        data: {
          project_id,
          action: action_num,
          fuel_csrf_token: fuel_csrf_token(),
        },
      });
    },
    set_cookie(project_id, prelogin) {
      let goods_array = this.get_cookie()
        .split(',')
        .filter(v => !!v);
      goods_array.push(project_id);
      goods_array = $.uniqueSort(goods_array);
      if (!prelogin && goods_array.length > 10) {
        return false;
      }
      if (goods_array.length > 11) {
        goods_array = goods_array.filter(v => v !== project_id);
      }
      const d = new Date();
      d.setFullYear(d.getFullYear() + 5);
      $.cookie(this.cookie_name, goods_array.join(','), {
        expires: d, // 5 years
        path: '/',
        secure: true,
      });
      return true;
    },
    get_cookie() {
      return $.cookie(this.cookie_name) || '';
    },
    remove_cookie(project_id) {
      if (project_id) {
        let goods_array = this.get_cookie()
          .split(',')
          .filter(v => !!v && v !== String(project_id));
        goods_array = $.uniqueSort(goods_array);
        const d = new Date();
        d.setFullYear(d.getFullYear() + 5);
        $.cookie(this.cookie_name, goods_array.join(','), {
          expires: d, // 5 years
          path: '/',
          secure: true,
        });
      } else {
        $.removeCookie(this.cookie_name);
      }
    },
    is_already(goods, target_project_id) {
      if (goods.length > 0) {
        const goods_array = goods.split(',');
        return goods_array.some(
          project_id => project_id === String(target_project_id),
        );
      }
      return false;
    },
  };
});
